import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

import { getConfigData } from 'redux/selectors/global';
import Typography from 'components/core/Typography/Typography';
import Icon, { IconName } from 'components/core/Icon/Icon';
import Button, { ButtonVariants } from 'components/core/Button/Button';
import CopyToClipboard from 'components/widgets/copyToClipboard/CopyToClipboard';
import { Typographies } from 'models/uiElements';
import { openLinkInNewTab } from 'utilities/window';
import { buildDemoUrl, onClickSignUpButton } from 'utilities/demo';
import { trackDocsClick } from 'utilities/analytics/demo';

const ShareDemoModal = () => {
  const { hosted_page_docs_url: docs } = useSelector(getConfigData);

  return (
    <StyledModalWrapper>
      <StyledWrapper>
        <StyledHeaderIcon name={IconName.SHARE_2} />
        <Title name="share-demo-title" type={Typographies.H5_HEADING}>
          {'Share Demo'}
        </Title>
      </StyledWrapper>
      <SubTitle name="share-demo-subtitle" type={Typographies.BODY1}>
        {'You can share the demo link with your associates.'}
      </SubTitle>
      <CopyToClipboard
        inputValue={'checkout.rapyd.net/demo'}
        textToCopy={buildDemoUrl()}
      />
      <ButtonsWrapper>
        <SignUpButton variant={ButtonVariants.TEXT} onClick={onClickSignUpButton}>
          <StyledIcon name={IconName.USER} />
          {'Sign up'}
        </SignUpButton>
        <DocsButton
          variant={ButtonVariants.OUTLINED}
          onClick={() => {
            trackDocsClick();
            openLinkInNewTab(docs);
          }}
        >
          <StyledIcon name={IconName.OPEN_LINK} />
          {'Explore the Docs'}
        </DocsButton>
      </ButtonsWrapper>
    </StyledModalWrapper>
  );
};

export default ShareDemoModal;

const StyledModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${({ theme }) => theme.colors.grey.grey100};
`;
const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Title = styled(Typography)`
  display: flex;
  justify-content: center;
  padding: 2rem 0;
`;

const SubTitle = styled(Typography)`
  display: block;
  text-align: center;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  margin-bottom: 2rem;
`;

const StyledButton = styled(Button)`
  display: flex;
  width: 13rem;
  height: 3.2rem;
  padding: 1.6rem;
  height: 4.4rem;
`;

const DocsButton = styled(StyledButton)`
  width: 21rem;
  margin-right: 2rem;
`;

const SignUpButton = styled(StyledButton)`
  width: 13rem;
`;

const StyledHeaderIcon = styled(Icon)`
  font-size: 2.5rem;
  margin-bottom: 0.4rem;
  margin-right: 0.7rem;
`;

const StyledIcon = styled(Icon)`
  font-size: 1.6rem;
  margin-right: 0.7rem;
`;
